// =============================================================================
//
// FILE:
// src/modules/finance/services/cashFlowService.js
//
// MODULE:
// Finance & Accounts Management System (FBAMS)
//
// FEATURE:
// Cash Flow Statement
//
// PURPOSE:
// API service for Cash Flow report.
//
// METHODS:
// - DIRECT
// - INDIRECT
//
// =============================================================================

import apiClient from "../../../api/axiosClient";


// =============================================================================
// GET CASH FLOW
// =============================================================================

const getCashFlow = async ({
    company_id,
    financial_year_id,
    financial_period_id = null,
    cash_flow_method = "INDIRECT",
}) => {

    const params = {

        company_id,

        financial_year_id,

        cash_flow_method,

    };


    // -------------------------------------------------------------------------
    // Financial Period is optional.
    // Do not send null unnecessarily.
    // -------------------------------------------------------------------------

    if (
        financial_period_id
    ) {

        params.financial_period_id =
            financial_period_id;

    }


    // -------------------------------------------------------------------------
    // CALL CASH FLOW API
    // -------------------------------------------------------------------------

    const response =
        await apiClient.get(
            "/api/finance/cash-flow",
            {
                params,
            }
        );


    // -------------------------------------------------------------------------
    // EXISTING FINANCE API RESPONSE FORMAT
    //
    // {
    //     success: true,
    //     message: "...",
    //     data: {...}
    // }
    // -------------------------------------------------------------------------

    return (
        response?.data?.data ||
        response?.data ||
        null
    );

};


// =============================================================================
// EXPORT
// =============================================================================

export default {
    getCashFlow,
};